var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicStatusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 19,
    height: 18,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Clinic_Status_White_with_Plus_Icon_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clinic_Status_White_with_Plus_Icon_2",
    "data-name": "Clinic Status White with Plus Icon \\u2013 2",
    clipPath: "url(#clip-Clinic_Status_White_with_Plus_Icon_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3856",
    "data-name": "Group 3856",
    transform: "translate(-346.094 -341.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855",
    transform: "translate(346.094 341.241)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831",
    transform: "translate(-145.684 -129.005)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6281",
    "data-name": "Path 6281",
    d: "M208.687,212.7l-5.917,8.174h5.859v1.367h-8.213v-.5l5.918-8.135h-5.361v-1.367h7.714Z",
    transform: "translate(-200.416 -212.241)",
    fill: "#5e5e5e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3830",
    "data-name": "Group 3830",
    transform: "translate(9.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6282",
    "data-name": "Path 6282",
    d: "M217.73,212.7l-5.918,8.174h5.86v1.367h-8.213v-.5l5.918-8.135h-5.361v-1.367h7.714Z",
    transform: "translate(-209.459 -212.241)",
    fill: "#5e5e5e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834",
    transform: "translate(-146.084 -129.405)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3832",
    "data-name": "Group 3832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6283",
    "data-name": "Path 6283",
    d: "M209.029,222.641h-9.013v-1.028l5.532-7.605h-4.975v-2.167h8.514v.989l-5.534,7.644h5.476Zm-8.19-.8h7.39v-.567h-6.243l6.25-8.633h-6.863v.567h5.747Z",
    transform: "translate(-200.016 -211.841)",
    fill: "#5e5e5e"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833",
    transform: "translate(9.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6284",
    "data-name": "Path 6284",
    d: "M218.072,222.641h-9.013v-1.028l5.532-7.605h-4.975v-2.167h8.514v.989l-5.534,7.644h5.476Zm-8.19-.8h7.39v-.567h-6.243l6.25-8.633h-6.863v.567h5.747Z",
    transform: "translate(-209.059 -211.841)",
    fill: "#5e5e5e"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Line_1",
    "data-name": "Line 1",
    transform: "translate(11.88 6.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3835",
    "data-name": "Group 3835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6285",
    "data-name": "Path 6285",
    d: "M358.373,357.523a.4.4,0,0,1-.4-.4v-8.867a.4.4,0,1,1,.8,0v8.867A.4.4,0,0,1,358.373,357.523Z",
    transform: "translate(-357.973 -347.856)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Line_2",
    "data-name": "Line 2",
    transform: "translate(1.321 6.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    "data-name": "Group 3836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6286",
    "data-name": "Path 6286",
    d: "M347.815,357.522a.4.4,0,0,1-.4-.4v-8.729a.4.4,0,0,1,.8,0v8.729A.4.4,0,0,1,347.815,357.522Z",
    transform: "translate(-347.415 -347.993)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Path_305",
    "data-name": "Path 305",
    transform: "translate(0.255 15.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6287",
    "data-name": "Path 6287",
    d: "M359.839,359.453h-13.49v-2.73h4.6a.4.4,0,1,1,0,.8h-3.8v1.13h11.888v-1.13h-3.882a.4.4,0,0,1,0-.8h4.683Z",
    transform: "translate(-346.349 -356.723)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Path_306",
    "data-name": "Path 306",
    transform: "translate(4.539 16.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6288",
    "data-name": "Path 6288",
    d: "M355.158,359.453a.4.4,0,0,1-.4-.4v-.565h-3.324v.565a.4.4,0,0,1-.8,0v-1.365h4.926v1.365A.4.4,0,0,1,355.158,359.453Z",
    transform: "translate(-350.633 -357.688)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Path_307",
    "data-name": "Path 307",
    transform: "translate(5.201 15.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6289",
    "data-name": "Path 6289",
    d: "M354.5,358.488a.4.4,0,0,1-.4-.4v-.565h-2v.565a.4.4,0,0,1-.8,0v-1.365h3.6v1.365A.4.4,0,0,1,354.5,358.488Z",
    transform: "translate(-351.295 -356.723)",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Path_308",
    "data-name": "Path 308",
    transform: "translate(5.2 11.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6290",
    "data-name": "Path 6290",
    d: "M354.494,357.523a.4.4,0,0,1-.4-.4v-3.531h-2v3.531a.4.4,0,0,1-.8,0v-4.331h3.6v4.331A.4.4,0,0,1,354.494,357.523Z",
    transform: "translate(-351.294 -352.792)",
    fill: "#fff"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Path_315",
    "data-name": "Path 315",
    transform: "translate(0.275 6.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6291",
    "data-name": "Path 6291",
    d: "M359.42,348.641H346.77a.4.4,0,1,1,0-.8h12.65a.4.4,0,0,1,0,.8Z",
    transform: "translate(-346.369 -347.841)",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Path_307-2",
    "data-name": "Path 307-2",
    transform: "translate(9.114 13.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6292",
    "data-name": "Path 6292",
    d: "M357.317,355.979h-1.709a.4.4,0,0,1,0-.8h1.709a.4.4,0,1,1,0,.8Z",
    transform: "translate(-355.208 -355.179)",
    fill: "#fff"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Path_308-2",
    "data-name": "Path 308-2",
    transform: "translate(9.114 11.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6293",
    "data-name": "Path 6293",
    d: "M357.317,355.975a.4.4,0,0,1-.4-.4v-2h-.908v2a.4.4,0,0,1-.8,0v-2.8h2.51v2.8A.4.4,0,0,1,357.317,355.975Z",
    transform: "translate(-355.208 -352.775)",
    fill: "#fff"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Path_307-3",
    "data-name": "Path 307-3",
    transform: "translate(2.647 13.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6294",
    "data-name": "Path 6294",
    d: "M350.851,355.979h-1.709a.4.4,0,1,1,0-.8h1.709a.4.4,0,0,1,0,.8Z",
    transform: "translate(-348.741 -355.179)",
    fill: "#fff"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Path_308-3",
    "data-name": "Path 308-3",
    transform: "translate(2.647 11.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6295",
    "data-name": "Path 6295",
    d: "M350.851,355.975a.4.4,0,0,1-.4-.4v-2h-.908v2a.4.4,0,0,1-.8,0v-2.8h2.51v2.8A.4.4,0,0,1,350.851,355.975Z",
    transform: "translate(-348.741 -352.775)",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Path_307-4",
    "data-name": "Path 307-4",
    transform: "translate(8.978 10.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6296",
    "data-name": "Path 6296",
    d: "M357.182,352.38h-1.709a.4.4,0,1,1,0-.8h1.709a.4.4,0,0,1,0,.8Z",
    transform: "translate(-355.072 -351.58)",
    fill: "#fff"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Path_308-4",
    "data-name": "Path 308-4",
    transform: "translate(8.978 7.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6297",
    "data-name": "Path 6297",
    d: "M357.182,352.38a.4.4,0,0,1-.4-.4v-2h-.908v2a.4.4,0,0,1-.8,0v-2.8h2.51v2.8A.4.4,0,0,1,357.182,352.38Z",
    transform: "translate(-355.072 -349.18)",
    fill: "#fff"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Path_307-5",
    "data-name": "Path 307-5",
    transform: "translate(2.512 10.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6298",
    "data-name": "Path 6298",
    d: "M350.716,352.38h-1.709a.4.4,0,1,1,0-.8h1.709a.4.4,0,0,1,0,.8Z",
    transform: "translate(-348.606 -351.58)",
    fill: "#fff"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Path_308-5",
    "data-name": "Path 308-5",
    transform: "translate(2.512 7.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6299",
    "data-name": "Path 6299",
    d: "M350.716,352.38a.4.4,0,0,1-.4-.4v-2h-.908v2a.4.4,0,0,1-.8,0v-2.8h2.51v2.8A.4.4,0,0,1,350.716,352.38Z",
    transform: "translate(-348.606 -349.18)",
    fill: "#fff"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Path_307-6",
    "data-name": "Path 307-6",
    transform: "translate(5.746 10.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6300",
    "data-name": "Path 6300",
    d: "M353.949,352.38H352.24a.4.4,0,1,1,0-.8h1.709a.4.4,0,1,1,0,.8Z",
    transform: "translate(-351.84 -351.58)",
    fill: "#fff"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Path_308-6",
    "data-name": "Path 308-6",
    transform: "translate(5.746 7.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    "data-name": "Group 3851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6301",
    "data-name": "Path 6301",
    d: "M353.949,352.38a.4.4,0,0,1-.4-.4v-2h-.908v2a.4.4,0,0,1-.8,0v-2.8h2.51v2.8A.4.4,0,0,1,353.949,352.38Z",
    transform: "translate(-351.84 -349.18)",
    fill: "#fff"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Path_5964",
    "data-name": "Path 5964",
    transform: "translate(3.96 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3852",
    "data-name": "Group 3852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6302",
    "data-name": "Path 6302",
    d: "M354.393,347.65h-2.271a.4.4,0,0,1-.4-.4v-1.268h-1.268a.4.4,0,0,1-.4-.4v-2.268a.4.4,0,0,1,.4-.4h1.439v-1.268a.4.4,0,0,1,.4-.4h2.1a.4.4,0,0,1,.4.4v1.268h1.268a.4.4,0,0,1,.4.4v2.268a.4.4,0,0,1-.4.4h-1.268v1.268A.4.4,0,0,1,354.393,347.65Zm-1.871-.8h1.47v-1.268a.4.4,0,0,1,.4-.4h1.267v-1.468h-1.267a.4.4,0,0,1-.4-.4v-1.268h-1.3v1.268a.4.4,0,0,1-.4.4h-1.438v1.468h1.268a.4.4,0,0,1,.4.4Z",
    transform: "translate(-350.054 -341.246)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3854",
    "data-name": "Group 3854",
    transform: "translate(12.975 9.482)",
    style: {
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3853",
    "data-name": "Group 3853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6303",
    "data-name": "Path 6303",
    d: "M364.586,354.321h-1.919v1.919h-1.68v-1.919h-1.919v-1.679h1.919v-1.919h1.68v1.919h1.919Z",
    transform: "translate(-359.068 -350.723)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicStatusWhite);
export default __webpack_public_path__ + "static/media/clinic-status-white.e9dcfd3d5f48c51acae937bdd78e8638.svg";
export { ForwardRef as ReactComponent };